import { MenuPayloadDto } from '../models';

/**
 * Mock danych menu z backendu
 * W przyszłości zastąpione prawdziwym API
 */
export const MENU_MOCK: MenuPayloadDto = {
  items: [
    {
      id: 2,
      name: 'Akademia Testowa',
      slug: 'akademia-testowa',
      projects: [
        {
          id: 201,
          name: 'Projekt Gamma',
          slug: 'projekt-gamma',
          children: [
            {
              id: 2001,
              name: 'Ustawienia',
              route: '/settings',
              slug: 'ustawienia'
            }
          ]
        }
      ]
    }
  ]
};
